<template>
  <div class="content">
    <h3 class="header-title">商品收藏</h3>
    <div class="wrapper" v-loading="loading">
      <div class="good-list" v-if="goodList.length">
        <div class="good-wrapper" v-for="(good, index) in goodList" :key="good.id">
          <el-button class="star" size="small" type="primary"
                     @click.stop="toggleCollect(good, index)"
                     icon="el-icon-delete" circle></el-button>
          <good-card size="200px" :good="good"></good-card>
        </div>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="{ total, pageSize, currentPage: pageNum }" @callFather="handlePageChange"></Pagination>
      </div>
      <empty v-else>暂无收藏商品</empty>
    </div>
  </div>
</template>
<script>
import {collection_list, removeCollection} from "@/api/xunyou";
import GoodCard from '@/components/good-card'
import Pagination from '@/components/Pagination';
export default {
  data() {
    return {
      loading: false,
      total: 0,
      pageNum: 1,
      pageSize: 10,
      goodList: []
    };
  },
  // 注册组件
  components: {GoodCard, Pagination},
  created() {
    this.getCollectionGoods();
  },
  methods: {
    // 切换收藏状态
    toggleCollect(good, index) {
      const params = {
        type: 1, // 1:商品；2：店铺；必填
        uid: this.$store.getters.userId,
        cid: good.id
      }
      removeCollection(params).then(res => {
        console.log('收藏结果：', res);
        if (res.code === 0) {
          this.goodList.splice(index, 1);
          this.$message.success('已移除');
        }
      }).catch(err => {
        this.$message.error("操作失败，请稍后再试！");
      });
    },
    // 翻页
    handlePageChange (val) {
      this.pageSize = val.pageSize;
      this.pageNum = val.currentPage;
      this.getCollectionGoods();
    },
    getCollectionGoods() {
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        type: 1, //type:1:商品；2：店铺
        uid: this.$store.getters.userId
      }
      this.loading = true;
      collection_list(params).then((res) => {
        console.log('收藏商品：', res);
        this.loading = false;
        if (res.code === 0) {
          this.total = res.total;
          this.goodList = res.rows.map(ele => ele.commodity);
        } else {
          this.$message.error(res.msg);
        }
      }).catch((err) => {
        this.loading = false;
        this.$message.error("收藏商品查询失败，请稍后再试！");
      });
    }
  }
};
</script>

<style scoped lang="less">
.header-title{
  font-size: 20px;
  color: #666;
}
.good-list{
  padding: 10px 0;
  .good-wrapper{
    position: relative;
    display: inline-block;
    margin-right: 10px;
    margin-bottom: 10px;
    &:nth-child(4n+4) {
      margin-right: 0;
    }
    .star{
      position: absolute;
      top: 10px;
      right: 10px;
      z-index: 10;
      opacity: 0;
      transition: opacity 0.3s linear;
      box-shadow: 0px 0px 10px rgb(255,168,168);
    }
    &:hover .star{
      opacity: 1;
    }
  }
}
</style>







// WEBPACK FOOTER //
// src/views/myOrder/attentionCenter/goodsCollection.vue